import type { TVConfig } from '@nuxt/ui';
import type * as ui from '#build/ui';

export default {
    slots: {
        footer: 'justify-end',
    },
} satisfies TVConfig<typeof ui>['modal'];
